import React from 'react';
import { useTranslation } from 'react-i18next';
import readableFileSize from 'filesize';
import { formatDollars } from '../../../../../utils/formatting';
import { useIsCurrentUserDeviationAuthor } from '../../../../../utils/hooks/useIsCurrentUserDeviationAuthor';
import { useDeviationAttributes } from '../../../../../DeviationViews/hooks/useDeviationAttributes';
import { DownloadType } from '../utils';
import DownloadOption from '../DownloadOption';
import s from './DownloadOptions.scss';
var DownloadOptions = function (_a) {
    var pcp = _a.pcp, download = _a.download, deviation = _a.deviation, selectedType = _a.selectedType, hasAccessViaSubscription = _a.hasAccessViaSubscription, onSelect = _a.onSelect;
    var t = useTranslation().t;
    var isOwner = useIsCurrentUserDeviationAuthor(deviation);
    var isDownloadable = useDeviationAttributes(deviation, isOwner).isDownloadable;
    var fileTypesIncluded = (pcp.assets || [])
        .map(function (asset) { return asset.type && asset.type.toLocaleUpperCase(); })
        .filter(function (type, index, array) { return type && array.indexOf(type) === index; })
        .join(' ');
    var dollarPrice = formatDollars(pcp.downloadDollarPrice);
    var showPriceInPoints = pcp.downloadPrice && pcp.downloadPrice < 80;
    var titleKey = isOwner
        ? 'pcp.sellingFor'
        : showPriceInPoints
            ? 'pcp.buyForPoints'
            : 'pcp.buyForCurrency';
    var titleWithPrice = t(titleKey, {
        price: pcp.downloadPrice,
        dollars: dollarPrice,
    });
    var pcpOptionTitle = pcp.hasUserPurchased
        ? t('pcp.purchased')
        : titleWithPrice;
    if (hasAccessViaSubscription) {
        pcpOptionTitle = t('actionbar.pcp.purchasedThroughSubscription');
    }
    return (React.createElement("div", { className: s['checkboxes'] },
        isDownloadable && download && (React.createElement(DownloadOption, { value: DownloadType.FREE, title: t('pcp.free', {
                size: "".concat(download.width, "x").concat(download.height),
            }), onChange: onSelect, isChecked: selectedType === DownloadType.FREE })),
        React.createElement(DownloadOption, { value: DownloadType.PREMIUM, title: pcpOptionTitle, subtitle: t('pcp.zipFileDetails', {
                size: readableFileSize(pcp.zipFilesize || 0),
                types: fileTypesIncluded,
            }), onChange: onSelect, isChecked: selectedType === DownloadType.PREMIUM })));
};
DownloadOptions.displayName = 'DownloadOptions';
export default DownloadOptions;
//# sourceMappingURL=DownloadOptions.js.map